import * as Yup from 'yup';
import shouldBeAValidState from '../../../helpers/yup-valid-state';

Yup.addMethod(Yup.mixed, 'shouldBeAValidState', shouldBeAValidState);

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('Name or Company is required!'),
  relationship: Yup.string().required('Relationship is required'),
  address: Yup.string().ensure().required('Address is required!'),
  address2: Yup.string().nullable(),
  city: Yup.string().nullable(),
  state: Yup.string().ensure().shouldBeAValidState('interested-party.state'),
  zip: Yup.string().nullable()
});
